export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14682.2d6d5f55.jpg";